var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide-transition',[(_vm.isSuccess)?_c('div',{staticClass:"text-center"},[_c('check-mark',{attrs:{"color":"success","size":"x-large"}}),_c('atom-text',{attrs:{"color":"success"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }